export default __webpack_public_path__ + "static/vicky-62df896f7a83ad5f981caccfb4a7927d.png";